import * as React from "react";
import { Block } from "@block";
import images from "@styles/images";
import { ImageStyle } from "react-native";
import Animated, {
  Easing,
  Extrapolate,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from "react-native-reanimated";
import { useTheme, ActivityIndicator } from "react-native-paper";

const CustomSplashScreen = () => {
  const { colors } = useTheme();
  const imageStyles: ImageStyle = {
    width: undefined,
    height: 96,
    aspectRatio: 350 / 166,
  };
  const animationText = useSharedValue(0);

  React.useEffect(() => {
    animationText.value = withDelay(
      3000,
      withTiming(1, {
        duration: 1000,
        easing: Easing.linear,
      }),
    );
  }, [animationText]);

  const animatedTextStyles = useAnimatedStyle(() => {
    const opacity = interpolate(animationText.value, [0, 1], [0, 1], Extrapolate.CLAMP);
    return {
      marginTop: 12,
      opacity,
      fontFamily: "Montserrat-Medium",
      fontSize: 13,
    };
  });

  return (
    <>
      <Block flex={1} center middle>
        <Animated.Image style={[imageStyles]} source={images.logoPVCB_bg_white} />
        <ActivityIndicator style={{ marginTop: 16 }} size="small" color={colors.primary} />
        <Animated.Text style={[animatedTextStyles]} children="Vui lòng đợi trong giây lát..." />
      </Block>
    </>
  );
};

export default CustomSplashScreen;
